import React, { Component } from "react";
import { observer } from "mobx-react";
import moment from 'moment';
import { comma, commaString, partnerIcon, partnerText } from "utils/Utils";
import { fn_scroll_down, fn_scroll_up } from "function/FnScroll";
import { fn_product_detail_pop } from "function/FnBodySales"
import { fn_list_search } from "function/FnBodySearch";

@observer
class SalesProductDetail extends Component {
    constructor(props) {
        super(props);
        this.orderInfo = React.createRef();
        this.menuInfo = React.createRef();
    }

    render() {
        const { rootStore } = this.props;

        let layerStore = this.props.rootStore.layerStore;
        let salesStore = this.props.rootStore.salesStore;
        let startVal = salesStore.getSalesDateVal.start_val;
        let endVal = salesStore.getSalesDateVal.end_val;
        let channelList = [];
        if (salesStore.getSalesProductDetail.length != 0) {
            for (let i = 0; i < salesStore.getSalesProductDetail.orderChannels.length; i++) {
                let text = partnerText(salesStore.getSalesProductDetail.orderChannels[i])
                if (i == salesStore.getSalesProductDetail.orderChannels.length - 1) {
                    channelList.push(text)
                } else {
                    channelList.push(text + ", ")
                }
            }
        }

        return (
            <>
                <div className={"layer_comm " + (layerStore.getLayerProductDetailView ? ' layer_open' : '')}>
                    {/* <div className="layer_comm layer_order_detail layer_open"> */}
                    <div className="bg"></div>
                    <div className="layer_content">
                        <div className="article_common_type">
                            <div className="section_tit_comm">
                                <h1>상품별 상세정보</h1>
                            </div>
                            <div className="section_content">
                                <div className="clear_g">
                                    <ul className="wrap_sales_detail">
                                        <li className="first">
                                            <span className="tit">상품판매 내역</span>
                                            <span className="txt"><strong>조회기간</strong>&nbsp;&nbsp;&nbsp;
                                                {moment(startVal, "YYYYMMDDHHmmss").format("YYYY - MM - DD")} ~ {moment(endVal, "YYYYMMDDHHmmss").format("YYYY - MM - DD")}
                                            </span>
                                        </li>
                                        <li>
                                            <span className="tit name">상 품 명</span>
                                            <span className="txt">{salesStore.getSalesProductDetail.productName}</span>
                                        </li>
                                        <li>
                                            <span className="tit">주문채널</span>
                                            <span className="txt">
                                                {channelList
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span className="tit">판매수량</span>
                                            <span className="txt num"> {salesStore.getSalesProductDetail.saleCount} 개</span>
                                            <span className="sub">(전체 판매수량 중 {salesStore.getSalesProductDetail.saleCountShare}% 차지)</span>
                                        </li>
                                        <li>
                                            <span className="tit">매출금액</span>
                                            <span className="txt num"> {commaString(salesStore.getSalesProductDetail.saleAmount)} 원</span>
                                            <span className="sub">(전체 매출금액 중 {salesStore.getSalesProductDetail.saleAmountShare}% 차지)</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="btn_close btn_close_comm">
                                <button onClick={event => fn_product_detail_pop(rootStore, false)}>
                                    <span>닫기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default SalesProductDetail;